import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

export const AmazonService = {
  //   async GetAmazonOtp() {
  //     let response = await $axios
  //       .get($api("get_AmazonOtp"), {
  //         headers: {
  //           "Accept-Language": "az",
  //           Authorization: `Bearer ${getCookie("ColibriToken")}`,
  //         },
  //       })
  //       .catch((err) => {
  //         return err.response;
  //       });
  //     return {
  //       data: response?.data ? response?.data : [],
  //       status: response?.status,
  //     };
  //   },
  async GetAmazonOtp(url?: string) {
    let response = await $axios
      .get(url || $api("get_AmazonOtp"), {
        headers: {
          // "Accept-Language": "az",
          Authorization: `Bearer ${getCookie("ColibriToken")}`,
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async PostAmazonOtp(payload: any) {
    try {
      const response = await $axios.post($api("post_AmazonOtp"), payload);
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
  async EditAmazonOtp(payload: any) {
    try {
      const response = await $axios.post($api("edit_AmazonOtp"), payload);
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
};
